import axios from 'axios'
import router from '../router'
import { getToken, getRefreshToken, setToken, setRefreshToken, clearAuth } from './auth'

const request = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL || 'http://localhost:3000/api/v1',
  timeout: 10000,
  headers: { 'Content-Type': 'application/json', 'X-Client-Type': 'admin' }
})

request.interceptors.request.use(config => {
  const token = getToken()
  if (token) config.headers.Authorization = `Bearer ${token}`
  if (config.params) {
    config.params = Object.fromEntries(Object.entries(config.params).filter(([, value]) => value !== '' && value !== null && value !== undefined))
  }
  return config
})

let refreshPromise = null

request.interceptors.response.use(response => {
  const payload = response.data || {}
  if (payload.code !== 0) return Promise.reject(new Error(payload.message || '请求失败'))
  return payload.data
}, async error => {
  const status = error.response && error.response.status
  const original = error.config || {}
  const refreshToken = getRefreshToken()
  if (status === 401 && refreshToken && !original._retried && !String(original.url || '').includes('/auth/refresh-token')) {
    original._retried = true
    const remember = Boolean(localStorage.getItem('xxst_admin_refresh_token'))
    try {
      refreshPromise = refreshPromise || axios.post(`${request.defaults.baseURL}/auth/refresh-token`, { refreshToken }, { headers: { 'Content-Type': 'application/json', 'X-Client-Type': 'admin' } })
      const response = await refreshPromise
      const data = response.data?.data
      if (!data?.accessToken) throw new Error('登录状态刷新失败')
      setToken(data.accessToken, remember)
      setRefreshToken(data.refreshToken || refreshToken, remember)
      original.headers = { ...(original.headers || {}), Authorization: `Bearer ${data.accessToken}` }
      return request(original)
    } catch (refreshError) {
      clearAuth()
      if (router.currentRoute.path !== '/login') router.replace('/login')
      return Promise.reject(Object.assign(refreshError, { userMessage: '登录已过期，请重新登录' }))
    } finally {
      refreshPromise = null
    }
  }
  if (status === 401) {
    clearAuth()
    if (router.currentRoute.path !== '/login') router.replace('/login')
  }
  const message = error.response?.data?.message || error.message || '网络请求失败'
  return Promise.reject(Object.assign(error, { userMessage: message }))
})

export default request
